export const COLLECT_DATA_FROM_LIST = [
    { id: 'New Data Collection', name: 'New Data Collection'},
    { id: 'Existing Case Data', name: 'Existing Case Data'}
]